import { Grid } from '@material-ui/core';
import SkeletonPulse from './SkeletonPulse';

const SearchSkeletonLoader = () => {
  return (
    <Grid container spacing={1} direction="column">
      <Grid item>
        <SkeletonPulse width="300" height="30" backgroundColor="#030d2b" />
      </Grid>
      <Grid item>
        <SkeletonPulse width="500" height="20" backgroundColor="#030d2b" />
      </Grid>
      <Grid item>
        <SkeletonPulse width="500" height="20" backgroundColor="#030d2b" />
      </Grid>
    </Grid>
  );
};

export default SearchSkeletonLoader;
